import { Helmet } from 'react-helmet-async';
import React, { useEffect, useMemo } from 'react';

const EventMetadata = ({ event }) => {
  // Calculate metadata using useMemo to optimize performance
  const metadata = useMemo(() => {
    if (!event || event.length === 0) return null;

    const firstEvent = event[0];

    return {
      title: firstEvent.name,
      description: firstEvent.description,
      image: firstEvent.imageUrl,
      url: window.parent.location.href,
      eventId: firstEvent.id,
      firstEvent // Include for rendering
    };
  }, [event]);

  // Send metadata to parent window when in iframe
  useEffect(() => {
    if (metadata && typeof window !== 'undefined' && window !== window.parent) {
      window.parent.postMessage({
        type: 'UPDATE_METADATA',
        payload: {
          title: metadata.title,
          description: metadata.description,
          image: metadata.image,
          url: metadata.url,
          eventId: metadata.eventId,
        }
      }, window.wordpressData?.baseUrl || window.location.origin);
    }
  }, [metadata]);

  if (!metadata) return null;

  console.log(metadata);

  return (
    <Helmet>
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:title" content={metadata.firstEvent.name} />
      <meta property="og:description" content={metadata.description.substring(0, 300)} />
      <meta property="og:image" content={metadata.image} />
      <meta property="og:url" content={metadata.url} />
      <meta property="og:type" content="event" />
      <meta property="event:location" content="Jazz Forum Arts Club" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metadata.firstEvent.name} />
      <meta name="twitter:description" content={metadata.description.substring(0, 200)} />
      <meta name="twitter:image" content={metadata.image} />

      {/* Structured data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MusicEvent",
          "name": metadata.firstEvent.name,
          "location": {
            "@type": "Place",
            "name": "Jazz Forum Arts Club",
            "address": "1 Dixon Lane, Tarrytown, NY 10591"
          },
          "image": metadata.image,
          "description": metadata.description,
          "performer": {
            "@type": "MusicGroup",
            "name": metadata.firstEvent.attribute_MainArtist || "Featured Jazz Artists"
          },
          "offers": {
            "@type": "Offer",
            "url": metadata.url,
            "price": metadata.firstEvent.prices?.toString() || "0",
            "priceCurrency": "USD",
            "availability": metadata.firstEvent.availableStatus ? 
              "https://schema.org/InStock" : "https://schema.org/SoldOut",
            "validFrom": new Date().toISOString()
          }
        })}
      </script>
    </Helmet>
  );
};

export default EventMetadata;